export default __webpack_public_path__ + "static/media/full_gray.a4e8a1b7.svg";